import { render } from "./AuthorizedAccess.vue?vue&type=template&id=52acaa45"
import script from "./AuthorizedAccess.vue?vue&type=script&lang=js"
export * from "./AuthorizedAccess.vue?vue&type=script&lang=js"
script.render = render

export default script